import ShopifyApi from 'utils/wishlist/shopify-api';
import BrowserApi from 'utils/wishlist/browser-api';

class Wishlist {
  api: ShopifyApi | BrowserApi;

  constructor() {
    this.api = theme.customer ? new ShopifyApi() : new BrowserApi();
  }
}

const wishlist = new Wishlist();

export default wishlist;
